"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartSchemaValidator = exports.OrderByChart = exports.ChartType = exports.SummarizeChartType = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const tab_1 = require("../../tab");
var SummarizeChartType;
(function (SummarizeChartType) {
    SummarizeChartType["AVG"] = "AVG";
    SummarizeChartType["SUM"] = "SUM";
    SummarizeChartType["COUNT"] = "COUNT";
    SummarizeChartType["MAX"] = "MAX";
    SummarizeChartType["MIN"] = "MIN";
})(SummarizeChartType = exports.SummarizeChartType || (exports.SummarizeChartType = {}));
var ChartType;
(function (ChartType) {
    ChartType["BAR"] = "BAR";
    ChartType["LINE"] = "LINE";
    ChartType["SCATTER"] = "SCATTER";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
var OrderByChart;
(function (OrderByChart) {
    OrderByChart["X_AXIS"] = "X_AXIS";
    OrderByChart["Y_AXIS"] = "Y_AXIS";
})(OrderByChart = exports.OrderByChart || (exports.OrderByChart = {}));
const orientationType = zod_1.z.enum(['vertical', 'horizontal']);
const chartType = zod_1.z.nativeEnum(ChartType);
const datasetSchema = zod_1.z.object({
    color: zod_1.z.string(),
    columnId: zod_1.z.string(),
    columnName: zod_1.z.string().optional(),
    summarize: zod_1.z.nativeEnum(SummarizeChartType),
    label: zod_1.z.string(),
    chartType: chartType.optional().default(ChartType.BAR),
});
const orderOptions = zod_1.z.object({
    order_by: zod_1.z.nativeEnum(OrderByChart),
    order_type: zod_1.z.nativeEnum(tab_1.OrderType),
});
const advancedOptions = zod_1.z
    .object({
    x_axis_title: zod_1.z.string().optional(),
    y_axis_title: zod_1.z.string().optional(),
    order_options: orderOptions.optional(),
    max_per_page: zod_1.z.number().optional(),
})
    .optional();
exports.chartSchemaValidator = zod_1.z.intersection(common_1.commonTypeSchemaValidator, zod_1.z.object({
    type: orientationType,
    label_column: zod_1.z.string(),
    filter: common_1.widgetFilterValidator.optional(),
    dataset_columns: zod_1.z.array(datasetSchema),
    chart_advanced_options: advancedOptions,
}));
